import env from '@framework/env/env';

export interface ISearchEngineConfig {
  allowIndexing: boolean,
}

const searchEngineConfig: ISearchEngineConfig = {
  allowIndexing: env('SE__ALLOW_INDEXING') === 'true',
};

export default searchEngineConfig;
